<template>
  <div class="explore-main">
    <div class="explore-header">
      <h1>{{ sectionData.field_1 }}</h1>
      <p>{{ sectionData.field_2 }}</p>
      <p>&nbsp;</p>
    </div>
    <div class="pioneer-explore-container">
      <div class="image-container" @mousemove="handleMouseMove">
        <div class="image-wrapper">
          <img class="pioneer-img" :src="sectionData.field_5" alt="Map"
            ref="imageRef" />
          <div v-for="(coord, index) in coordinates" :key="index" class="hotspot"
            :style="{ top: coord.y + '%', left: coord.x + '%' }" @click="showTooltip(coord.text)">
            <img src="https://assets.rhinorack.com/pioneer6/hotspot_icon/icon.svg" alt="Hotspot" />
            <div v-if="coord.showTooltip" class="tooltip"
            :style="tooltipStyle(index, coord.y, coord.x)"
              >{{ coord.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-carousel">
      <div class="carousel-wrapper" v-explore-touch>
        <div class="section-item" v-for="(item, index) in sectionData.section_items" :key="index" :id="'item-' + index" :class="{ 'highlighted-item': 'item-' + index === selectedCarouselItem }">
          <div class="item-img" v-if="item.field_2 && item.field_2 != ''">
            <img :src="item.field_2" alt="">
          </div>
          <div class="item-txt">
            <p> {{ item.field_1 }}</p>
          </div>
        </div>
      </div>
    </div>
     <div class="carousel-btns">
          <li class="left-btn" @click="scrollData('left')" data-type="left"></li>
          <li class="right-btn" @click="scrollData('right')" data-type="right"></li>
      </div>  
  </div>
</template>

<script>
import pioneer6ExploreMixin from "../mixins/pioneer6-explore-mixin";

export default {
  name: "pioneer6-explore-v2",
  mixins: [pioneer6ExploreMixin],
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
      selectedCarouselItem: null,
      coordinates: [
        { id: 1, x: 60, y: 26, text: "One", showTooltip: false },
        { id: 2, x: 43, y: 39, text: "Two", showTooltip: false },
        { id: 3, x: 75, y: 43, text: "Three", showTooltip: false },
        { id: 4,  x: 21, y: 22, text: "Four", showTooltip: false },
        { id: 5, x: 50, y: 70, text: "Five", showTooltip: false },
      ],
    };
  },
  mounted() {
    try {
      this.sectionData = JSON.parse(this.section);
      if (this.sectionData) {

        var content = this.sectionData.section_items;

        content.forEach((field, index) => {
          if (this.coordinates[index]) {
            this.coordinates[index].text = field.field_1;
          }
        });
      }
      this.selectedCarouselItem = 'item-0';
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
    this.$refs.imageRef.addEventListener("load", this.handleImageLoad);
  },
  methods: {},
  beforeDestroy() {
    this.$refs.imageRef.removeEventListener("load", this.handleImageLoad);
  },
};
</script>